import { components, operations } from '~~/api-types';
import { useApi } from '~/api/index';

export type PaginatedBudgetMetricsResponseDto =
  components['schemas']['PaginatedBudgetMetricsResponseDto'];

export type BudgetMetricResponseDto =
  components['schemas']['BudgetMetricResponseDto'];

export type BudgetResponseDto = components['schemas']['BudgetResponseDto'];

export type GetBudgetMetricsListQueryParams =
  operations['AppGetBudgetMetricsListEndpoint_handler']['parameters']['query'];

export const apiGetBudget = (): Promise<BudgetResponseDto> => {
  const api = useApi();

  return api('/app/budgets/active', {
    method: 'GET',
  });
};

export const apiGetBudgetActivity = (
  params: GetBudgetMetricsListQueryParams,
): Promise<PaginatedBudgetActivityResponseDto> => {
  const api = useApi();

  return api('/app/budgets/metrics', {
    method: 'GET',
    params,
  });
};

export enum BudgetType {
  CO_FINANCED = 'co-financed',
  FULLY_FINANCED = 'fully-financed',
}
